import React from "react";
const Footer = ({ channelData }) => {
  console.log(channelData);
  return (
    <footer>
      <p className="copy-right">{channelData.copywrite}</p>
      <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#Home"><i className="icon-up-open" /></a></div>
    </footer>
  );
}
export default Footer;